import React, { useEffect, useState } from 'react';
import HeaderCard from '../../../components/Header/HeaderCard';
import TableList from '../../../components/Tools/TableList';
import { apiService } from '../../../components/Config/api.service';

function Contracts() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total_pages: 1,
        total_count: 0
    });
    
    const columns = [
        { key: 'Name', label: 'Name' },
        { key: 'Employee', label: 'Employee' },
        { key: 'Start Date', label: 'Start Date' },
        { key: 'End Date', label: 'End Date' },
        { 
            key: 'Statut', 
            label: 'Statut',
            render: (row) => {
                let badgeClass = '';
                let statusText = '';
                
                switch(row.Statut?.toLowerCase()) {
                    case 'open':
                        badgeClass = 'badge-success';
                        statusText = 'En cours';
                        break;
                    case 'close':
                        badgeClass = 'badge-error';
                        statusText = 'Expiré';
                        break;
                    case 'draft':
                        badgeClass = 'badge-info';
                        statusText = 'Nouveau';
                        break;
                    default:
                        badgeClass = 'badge-neutral';
                        statusText = row.Statut || 'N/A';
                }
                
                return <span className={`badge ${badgeClass}`}>{statusText}</span>;
            }
        },
    ];
    
    const fetchContracts = (page = 1, search = '') => {
        setLoading(true);
        
        const offset = (page - 1) * pagination.limit;
        
        const params = new URLSearchParams();
        params.append('offset', offset);
        params.append('limit', pagination.limit);
        if (search) {
            params.append('search', search);
        }
        
        apiService.getElement(`/contracts?${params.toString()}`)
            .then(response => {
                setData(response.data.contracts);
                const responseData = response.data;
                if (responseData.pagination) {
                    const currentPage = Math.floor(responseData.pagination.offset / responseData.pagination.limit) + 1;
                    
                    setPagination({
                        ...responseData.pagination,
                        page: currentPage 
                    });
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchContracts(pagination.page, searchTerm);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagination.page, searchTerm]);

    const handlePageChange = (page, search) => {
        const newSearchTerm = search !== undefined ? search : searchTerm;
        if (newSearchTerm !== searchTerm) {
            setSearchTerm(newSearchTerm);
        }
        fetchContracts(page, newSearchTerm);
    };

    return (
        <div>
            <div className="container mx-auto">
                <div className="">  
                    <HeaderCard
                        title="Gestion des Contrats"
                        text="Gérez les contrats de votre entreprise en toute simplicité."                        
                        exportProps={{
                            model_name: 'contract',
                            domain: [],
                            importUrl: '/contracts/import',
                            onImportSuccess: () => fetchContracts(pagination.page, searchTerm),
                        }}
                        goBack={
                            () => window.history.back()
                        }
                    />
                </div>
                
                <div className="">
                    {loading ? (
                        <div className="flex justify-center p-8">
                            <div className="loading loading-spinner text-primary"></div>
                        </div>
                    ) : (
                        <TableList 
                            columns={columns} 
                            data={data} 
                            pagination={pagination}
                            onPageChange={handlePageChange}
                            searchDisplay={false}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default Contracts;